<template>
  <video-background type="foot">
    <div v-if="showText" class="flex flex-col w-full text-center mt-24 px-10">
      <h1 class="screen-info">{{ $t('footscan.creating_3d_foot') }}</h1>
      <p v-if="errorMsg" class="error">{{ errorMsg }}</p>
    </div>
  </video-background>
</template>

<script>
import { mapActions } from 'vuex';
import page from '@/mixins/page';
import ScanProcess from '@/modules/scan-process';
import autoClearTimer from '@/mixins/auto-clear-timer';
import audioPlayer from '@/mixins/audio-player';

import VideoBackground from '@/components/common/VideoBackground.vue';

export default {
  name: 'Analyzing',
  mixins: [page, audioPlayer, autoClearTimer],
  props: {
    second: Boolean,
    foot: Boolean,
  },
  components: {
    VideoBackground,
  },
  async mounted() {
    this.errorTimer = setTimeout(() => {
      this.leaveWithError('Something went wrong. Please try again later.');
    }, 180000);
    this.playAudio('foot_creating_3d');
    setTimeout(() => {
      this.showText = true;
    }, 5000);
    try {
      await Promise.all([this.clearScanRecords(1), this.waitFinish()]);
    } catch (e) {
      this.leaveWithError(e);
    }
  },
  beforeDestroy() {
    if (typeof this.errorTimer !== 'undefined') {
      clearTimeout(this.errorTimer);
    }
  },
  data: () => ({
    showText: false,
    errorMsg: '',
    url: '',
  }),
  methods: {
    ...mapActions('user', ['clearScanRecords']),
    leaveWithError(error) {
      const msg = typeof error === 'string' ? error : error.message;
      this.errorMsg = msg;
      console.log(`[ERROR] Foot Wait finished failed: ${msg}`, error);
      this.$events.alert(msg);
      this.$events.goto('HomePage', {
        params: { failed: true },
      });
    },
    async waitFinish() {
      const { url } = await ScanProcess.waitFinish();
      if (!url) {
        console.log('Failed to get 3D model');
        throw Error('Failed to get 3D model');
      }

      this.$store.commit('user/SET_FEET_OBJ_URL', url);
      this.url = url;
    },
    next() {
      this.$events.goto('FootScan/ShowResult');
    },
  },
  computed: {
    canProceed() {
      return !!this.url;
    },
  },
  watch: {
    canProceed(nv) {
      if (nv) {
        this.next();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.screen-info {
  font-size: 32px;
  line-height: 1.56;
  color: #ffffff;
  z-index: 1;
}
.error {
  color: red;
  z-index: 1;
}
</style>
